import {useMutationCoordinate, useQueryAsUser} from "../../clients/graphql/graphql.hooks";
import {JediPopularAssetsQuery, JediYodaTradeMutation} from "../../clients/graphql/pages/assets-queries";
import {
    Alert,
    CircularProgress,
    Dialog,
    DialogContent,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText, ToggleButton, ToggleButtonGroup
} from "@mui/material";
import React, {useState} from "react";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

interface Asset{
    assetKey: number,
    assetType: string,
    symbol: string,
    name: string,
    pictureUrl: string,
}

interface PopularAssetsListProps {
    info: {
        userKey?: number;
        institutionKey?: number;
    }
}

function randomPrice() {
    return Math.floor(Math.random() * 300);
}

export const PopularAssetsList: React.FC<PopularAssetsListProps> = ({ info }) =>{

    const [selectedAsset, setSelectedAsset] = useState<Asset | null>(null);
    const [choice, setChoice] = useState('buy');
    const [shares, setShares] = useState("");

    const handleChange = (event: React.MouseEvent<HTMLElement>, choice: string) => {
        if (choice !== null) {
            setChoice(choice);
        }
    };

    const {data, loading, error} = useQueryAsUser(JediPopularAssetsQuery, { userKey: info.userKey });

    const [tradeMutation, success] = useMutationCoordinate(JediYodaTradeMutation, { variables: {
            institutionKey: info.institutionKey,
            symbol: selectedAsset?.symbol,
            quantity: shares,
            action: choice,
        }})

    if (error) return <Alert severity="error">{error?.message}</Alert>;

    if (loading) {
        return <CircularProgress size={60} sx={{ display: 'flex', justifySelf: "center", alignSelf: "center", margin: "auto"}} />;
    }

    const handleTrade = (event: React.MouseEvent<HTMLElement>, choice: string, shares: string) => {
        if (choice !== null) {
            setChoice(choice);
            setShares(shares);
        } else {
            return
            }
        tradeMutation()
        };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '33rem'}}>
        <Typography sx={{
            color: '#6D6D6D',
            font: 'Roboto',
            fontWeight: 500,
            fontSize: '13px',
            lineHeight: '12px',
            letterSpacing: '0.05em',
            marginTop: '1.5rem',
            marginLeft: '1rem',
        }} >
            POPULAR ASSETS
        </Typography>
            <List sx={{
                overflowY: 'auto',
                height: '30rem',
            }}
             >
            {data?.assetPopularGet?.assets.map((asset: Asset) => (
                <>
                <ListItem key={asset.assetKey} onClick={() => setSelectedAsset(asset)}>
                    <ListItemAvatar>
                        <Avatar src={asset.pictureUrl} alt={asset.symbol} />
                    </ListItemAvatar>
                    <ListItemText primary={asset.symbol} secondary={'$' + randomPrice()} />
                </ListItem>
                <Divider sx={{mx: '1rem'}}/>
                </>
            ))}

            {selectedAsset && (
                <Dialog open={true} onClose={() => setSelectedAsset(null)}>
                    <DialogContent sx={{ padding: '1rem' }}>
                        <Typography>Input desired shares of '{selectedAsset.symbol}'</Typography>
                        <TextField
                            type="number"
                            label="Shares"
                            fullWidth
                            sx={{ mt: 2 }}
                            value={shares}
                            onChange={(e) => setShares(e.target.value)}
                        />
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', paddingTop: '1rem' }}>
                        <ToggleButtonGroup
                            color="primary"
                            value={choice}
                            exclusive
                            onChange={handleChange}
                        >
                            <ToggleButton value="buy">Buy</ToggleButton>
                            <ToggleButton value="sell">Sell</ToggleButton>
                        </ToggleButtonGroup>
                        <Button
                            onClick={(event) => handleTrade(event, choice, shares)}
                            disabled={!choice || parseInt(shares) <= 0} // Disable button if invalid
                            variant="contained"
                        >Confirm</Button>
                    </Box>
                    </DialogContent>
                </Dialog>
            )}
        </List>
        </Box>
    );
};
